import { selectWindowIsDisabled } from 'base/core/selectors';
import React from 'react';
import { useSelector } from 'react-redux';

const DisableOverlay = () => {
  const windowIsDisabled = useSelector(selectWindowIsDisabled);
  return (
    <>
      {
        windowIsDisabled.display && (
          <div className="disable-overlay">
            <div className="overlay-content">
              <p>{windowIsDisabled.message}</p>
            </div>
          </div>
        )
      }
      {!windowIsDisabled.display && null}
    </>
  );
};

export default DisableOverlay;
